import React, { useEffect, useRef, useState } from 'react'
import { Button, Flex, Input, InputGroup, InputRightElement, Text, useDisclosure, useToast } from '@chakra-ui/react'
import * as S from '../styles'
import { AtualizaInfoPNota } from '../../../../services/api'
import ModalDialog from './ModalDialog'

export const ContentModalFinalizar = (props) => {
  const [loadingButton, setLoadingButton] = useState(false)
  const [formValues, setFormValues] = useState({})
  const [sair, setSair] = useState(false)
  const [guardaChuva, setGuardaChuva] = useState(false)
  const [focusfalse, setfocusfalse] = useState(false)
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const focusButton = useRef()
  console.log('FORM VALUES: ', formValues)

  function closeAll() {
    toast.closeAll()
  }

  useEffect(() => {
    props.dados_info_p_nota.map((data) => {
      setGuardaChuva(data.listar_caixas === 'S' ? true : false)
      setFormValues(
        data.listar_caixas === 'S'
          ? {
              ...formValues,
              numero_nota: data.numero_nota,
              cod_prod: data.cod_prod,
              sequencia: data.sequencia,
              id_guarda_chuva: data.id,
              usuario: props.usuario,
            }
          : {
              ...formValues,
              numero_nota: data.numero_nota,
              cod_prod: data.cod_prod,
              sequencia: data.sequencia,
              usuario: props.usuario,
            }
      )
    })
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      calcular()
      clearTimeout(timer)
    }, 500)
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      modificar()
      clearTimeout(timer)
    }, 500)
  })

  const focusInput = () => {
    document.getElementById('gramas').focus()
  }

  const enviarInfoPNota = async (e) => {
    //verificar se a quantidade de caixas vezes a quantidade de peças é maior que 20. se for, não deixa enviar

    for (let i = 1; i <= 10; i++) {
      const quantidade_por_caixa = formValues[`quantidade_por_caixa_id_${i}`]
      const quantidade_de_caixa = formValues[`quantidade_de_caixa_id_${i}`]
      const gramas = formValues.gramas

      const maxKg = 24

      if ((quantidade_por_caixa * gramas) / quantidade_de_caixa > maxKg) {
        toast({
          title: `O peso da caixa ${i} não pode ser maior que ${maxKg}!
          o peso que você está tentando enviar é de ${(quantidade_por_caixa * gramas) / quantidade_de_caixa}kg`,
        })
        return
      }
    }

    const param = formValues
    focusInput()
    if (
      document.getElementById('gramas').value === '' ||
      document.getElementById('gramas').value === 0 ||
      document.getElementById('gramas').value === '0' ||
      document.getElementById('gramas').value < '0.0001' ||
      document.getElementById('gramas').value === undefined ||
      document.getElementById('gramas').value === null
    ) {
      toast(
        {
          position: 'top',
          title: 'Preencha os campos',
          description: `É obrigatório preencher o campo ${document.getElementById('gramas').value === '' ? 'de peso' : ''}`,
          status: 'error',
          duration: 9000,
          isClosable: true,
        },
        closeAll(),
        onClose(),
        focusInput(),
        setfocusfalse(true),
        setTimeout(() => {
          setfocusfalse(false)
          clearTimeout()
        }, 10000)
      )
    } else {
      setLoadingButton(true)
      try {
        const response = await AtualizaInfoPNota.post('', param)
        console.log('resposta da api: ', response)

        const responsedata = response.data
        const timer = setTimeout(function () {
          setLoadingButton(false)
          clearTimeout(timer)
        }, 5000)
        toast({
          title: `${responsedata.mensagem}`,
          position: 'top',
          description: `Número do pedido: ${responsedata.result}`,
          status: 'success',
          duration: 9000,
          isClosable: true,
        })

        props.closeButton()
        props.FiltrarStatus()
      } catch (error) {
        toast({
          title: `Erro ao enviar.`,
          position: 'top',
          description: `entre em contato com o sistema.`,
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
        setLoadingButton(false)
        console.log(Object.keys(error), error.message)
      }
    }
  }

  document.onkeydown = function (e) {
    if (e.key === 'Escape') {
      setSair(true)
      const timer = setTimeout(function () {
        props.closeButton()
        clearTimeout(timer)
      }, 100)
    }
  }

  const enviarInputs = (e) => {
    e.preventDefault()

    enviarInfoPNota(e)
  }

  const handleInputOnChange = (e) => {
    const { name, value } = e.target

    console.log(name, value)

    setFormValues({
      ...formValues,
      [name]: value.toString().replace(',', '.'),
    })
  }

  const modificar = () => {
    if (guardaChuva) {
      document.getElementById('botao_adicionar_0').onclick = function () {
        document.getElementById('botao_adicionar_0').style.display = 'none'
        document.getElementById('botao_remover_0').style.display = 'block'
        document.getElementById('flex_0').style.display = 'flex'
        document.getElementById('caixa_adicional_id_0').focus()
      }
      document.getElementById('botao_adicionar_1').onclick = function () {
        document.getElementById('botao_adicionar_1').style.display = 'none'
        document.getElementById('botao_remover_1').style.display = 'block'
        document.getElementById('flex_1').style.display = 'flex'
        document.getElementById('caixa_adicional_id_1').focus()
      }
      document.getElementById('botao_adicionar_2').onclick = function () {
        document.getElementById('botao_adicionar_2').style.display = 'none'
        document.getElementById('botao_remover_2').style.display = 'block'
        document.getElementById('flex_2').style.display = 'flex'
        document.getElementById('caixa_adicional_id_2').focus()
      }
      document.getElementById('botao_adicionar_3').onclick = function () {
        document.getElementById('botao_adicionar_3').style.display = 'none'
        document.getElementById('botao_remover_3').style.display = 'block'
        document.getElementById('flex_3').style.display = 'flex'
        document.getElementById('caixa_adicional_id_3').focus()
      }
      document.getElementById('botao_adicionar_4').onclick = function () {
        document.getElementById('botao_adicionar_4').style.display = 'none'
        document.getElementById('botao_remover_4').style.display = 'block'
        document.getElementById('flex_4').style.display = 'flex'
        document.getElementById('caixa_adicional_id_4').focus()
      }
      document.getElementById('botao_adicionar_5').onclick = function () {
        document.getElementById('botao_adicionar_5').style.display = 'none'
        document.getElementById('botao_remover_5').style.display = 'block'
        document.getElementById('flex_5').style.display = 'flex'
        document.getElementById('caixa_adicional_id_5').focus()
      }
      document.getElementById('botao_adicionar_6').onclick = function () {
        document.getElementById('botao_adicionar_6').style.display = 'none'
        document.getElementById('botao_remover_6').style.display = 'block'
        document.getElementById('flex_6').style.display = 'flex'
        document.getElementById('caixa_adicional_id_6').focus()
      }
      document.getElementById('botao_adicionar_7').onclick = function () {
        document.getElementById('botao_adicionar_7').style.display = 'none'
        document.getElementById('botao_remover_7').style.display = 'block'
        document.getElementById('flex_7').style.display = 'flex'
        document.getElementById('caixa_adicional_id_7').focus()
      }
      document.getElementById('botao_adicionar_8').onclick = function () {
        document.getElementById('botao_adicionar_8').style.display = 'none'
        document.getElementById('botao_remover_8').style.display = 'block'
        document.getElementById('flex_8').style.display = 'flex'
        document.getElementById('caixa_adicional_id_8').focus()
      }
      document.getElementById('botao_adicionar_9').onclick = function () {
        document.getElementById('botao_adicionar_9').style.display = 'none'
        document.getElementById('botao_remover_9').style.display = 'block'
        document.getElementById('flex_9').style.display = 'flex'
        document.getElementById('caixa_adicional_id_9').focus()
      }

      document.getElementById('botao_remover_0').addEventListener('click', function () {
        document.getElementById('botao_remover_0').style.display = 'none'
        document.getElementById('botao_adicionar_0').style.display = 'block'
        document.getElementById('flex_0').style.display = 'none'
        document.getElementById('caixa_adicional_id_0').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_0').value = ''
        calcular()
      })
      document.getElementById('botao_remover_1').addEventListener('click', function () {
        document.getElementById('botao_remover_1').style.display = 'none'
        document.getElementById('botao_adicionar_1').style.display = 'block'
        document.getElementById('flex_1').style.display = 'none'
        document.getElementById('caixa_adicional_id_1').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_1').value = ''
        calcular()
      })
      document.getElementById('botao_remover_2').addEventListener('click', function () {
        document.getElementById('botao_adicionar_2').style.display = 'block'
        document.getElementById('botao_remover_2').style.display = 'none'
        document.getElementById('flex_2').style.display = 'none'
        document.getElementById('caixa_adicional_id_2').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_2').value = ''
        calcular()
      })
      document.getElementById('botao_remover_3').addEventListener('click', function () {
        document.getElementById('botao_remover_3').style.display = 'none'
        document.getElementById('botao_adicionar_3').style.display = 'block'
        document.getElementById('flex_3').style.display = 'none'
        document.getElementById('caixa_adicional_id_3').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_3').value = ''
        calcular()
      })
      document.getElementById('botao_remover_4').addEventListener('click', function () {
        document.getElementById('botao_remover_4').style.display = 'none'
        document.getElementById('botao_adicionar_4').style.display = 'block'
        document.getElementById('flex_4').style.display = 'none'
        document.getElementById('caixa_adicional_id_4').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_4').value = ''
        calcular()
      })
      document.getElementById('botao_remover_5').addEventListener('click', function () {
        document.getElementById('botao_remover_5').style.display = 'none'
        document.getElementById('botao_adicionar_5').style.display = 'block'
        document.getElementById('flex_5').style.display = 'none'
        document.getElementById('caixa_adicional_id_5').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_5').value = ''
        calcular()
      })
      document.getElementById('botao_remover_6').addEventListener('click', function () {
        document.getElementById('botao_remover_6').style.display = 'none'
        document.getElementById('botao_adicionar_6').style.display = 'block'
        document.getElementById('flex_6').style.display = 'none'
        document.getElementById('caixa_adicional_id_6').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_6').value = ''
        calcular()
      })
      document.getElementById('botao_remover_7').addEventListener('click', function () {
        document.getElementById('botao_remover_7').style.display = 'none'
        document.getElementById('botao_adicionar_7').style.display = 'block'
        document.getElementById('flex_7').style.display = 'none'
        document.getElementById('caixa_adicional_id_7').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_7').value = ''
        calcular()
      })
      document.getElementById('botao_remover_8').addEventListener('click', function () {
        document.getElementById('botao_remover_8').style.display = 'none'
        document.getElementById('botao_adicionar_8').style.display = 'block'
        document.getElementById('flex_8').style.display = 'none'
        document.getElementById('caixa_adicional_id_8').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_8').value = ''
        calcular()
      })
      document.getElementById('botao_remover_9').addEventListener('click', function () {
        document.getElementById('botao_remover_9').style.display = 'none'
        document.getElementById('botao_adicionar_9').style.display = 'block'
        document.getElementById('flex_9').style.display = 'none'
        document.getElementById('caixa_adicional_id_9').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_9').value = ''
        calcular()
      })
    } else {
      document.getElementById('botao_adicionar_0').onclick = function () {
        document.getElementById('botao_adicionar_0').style.display = 'none'
        document.getElementById('botao_remover_0').style.display = 'block'
        document.getElementById('flex_0').style.display = 'flex'
        document.getElementById('caixa_adicional_id_0').focus()
      }
      document.getElementById('botao_adicionar_1').onclick = function () {
        document.getElementById('botao_adicionar_1').style.display = 'none'
        document.getElementById('botao_remover_1').style.display = 'block'
        document.getElementById('flex_1').style.display = 'flex'
        document.getElementById('caixa_adicional_id_1').focus()
      }
      document.getElementById('botao_adicionar_2').onclick = function () {
        document.getElementById('botao_adicionar_2').style.display = 'none'
        document.getElementById('botao_remover_2').style.display = 'block'
        document.getElementById('flex_2').style.display = 'flex'
        document.getElementById('caixa_adicional_id_2').focus()
      }
      document.getElementById('botao_adicionar_3').onclick = function () {
        document.getElementById('botao_adicionar_3').style.display = 'none'
        document.getElementById('botao_remover_3').style.display = 'block'
        document.getElementById('flex_3').style.display = 'flex'
        document.getElementById('caixa_adicional_id_3').focus()
      }
      document.getElementById('botao_adicionar_4').onclick = function () {
        document.getElementById('botao_adicionar_4').style.display = 'none'
        document.getElementById('botao_remover_4').style.display = 'block'
        document.getElementById('flex_4').style.display = 'flex'
        document.getElementById('caixa_adicional_id_4').focus()
      }
      document.getElementById('botao_adicionar_5').onclick = function () {
        document.getElementById('botao_adicionar_5').style.display = 'none'
        document.getElementById('botao_remover_5').style.display = 'block'
        document.getElementById('flex_5').style.display = 'flex'
        document.getElementById('caixa_adicional_id_5').focus()
      }
      document.getElementById('botao_adicionar_6').onclick = function () {
        document.getElementById('botao_adicionar_6').style.display = 'none'
        document.getElementById('botao_remover_6').style.display = 'block'
        document.getElementById('flex_6').style.display = 'flex'
        document.getElementById('caixa_adicional_id_6').focus()
      }
      document.getElementById('botao_adicionar_7').onclick = function () {
        document.getElementById('botao_adicionar_7').style.display = 'none'
        document.getElementById('botao_remover_7').style.display = 'block'
        document.getElementById('flex_7').style.display = 'flex'
        document.getElementById('caixa_adicional_id_7').focus()
      }
      document.getElementById('botao_adicionar_8').onclick = function () {
        document.getElementById('botao_adicionar_8').style.display = 'none'
        document.getElementById('botao_remover_8').style.display = 'block'
        document.getElementById('flex_8').style.display = 'flex'
        document.getElementById('caixa_adicional_id_8').focus()
      }
      document.getElementById('botao_adicionar_9').onclick = function () {
        document.getElementById('botao_adicionar_9').style.display = 'none'
        document.getElementById('botao_remover_9').style.display = 'block'
        document.getElementById('flex_9').style.display = 'flex'
        document.getElementById('caixa_adicional_id_9').focus()
      }

      document.getElementById('botao_remover_0').addEventListener('click', function () {
        document.getElementById('botao_remover_0').style.display = 'none'
        document.getElementById('botao_adicionar_0').style.display = 'block'
        document.getElementById('flex_0').style.display = 'none'
        document.getElementById('caixa_adicional_id_0').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_0').value = ''
        calcular()
      })
      document.getElementById('botao_remover_1').addEventListener('click', function () {
        document.getElementById('botao_remover_1').style.display = 'none'
        document.getElementById('botao_adicionar_1').style.display = 'block'
        document.getElementById('flex_1').style.display = 'none'
        document.getElementById('caixa_adicional_id_1').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_1').value = ''
        calcular()
      })
      document.getElementById('botao_remover_2').addEventListener('click', function () {
        document.getElementById('botao_adicionar_2').style.display = 'block'
        document.getElementById('botao_remover_2').style.display = 'none'
        document.getElementById('flex_2').style.display = 'none'
        document.getElementById('caixa_adicional_id_2').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_2').value = ''
        calcular()
      })
      document.getElementById('botao_remover_3').addEventListener('click', function () {
        document.getElementById('botao_remover_3').style.display = 'none'
        document.getElementById('botao_adicionar_3').style.display = 'block'
        document.getElementById('flex_3').style.display = 'none'
        document.getElementById('caixa_adicional_id_3').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_3').value = ''
        calcular()
      })
      document.getElementById('botao_remover_4').addEventListener('click', function () {
        document.getElementById('botao_remover_4').style.display = 'none'
        document.getElementById('botao_adicionar_4').style.display = 'block'
        document.getElementById('flex_4').style.display = 'none'
        document.getElementById('caixa_adicional_id_4').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_4').value = ''
        calcular()
      })
      document.getElementById('botao_remover_5').addEventListener('click', function () {
        document.getElementById('botao_remover_5').style.display = 'none'
        document.getElementById('botao_adicionar_5').style.display = 'block'
        document.getElementById('flex_5').style.display = 'none'
        document.getElementById('caixa_adicional_id_5').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_5').value = ''
        calcular()
      })
      document.getElementById('botao_remover_6').addEventListener('click', function () {
        document.getElementById('botao_remover_6').style.display = 'none'
        document.getElementById('botao_adicionar_6').style.display = 'block'
        document.getElementById('flex_6').style.display = 'none'
        document.getElementById('caixa_adicional_id_6').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_6').value = ''
        calcular()
      })
      document.getElementById('botao_remover_7').addEventListener('click', function () {
        document.getElementById('botao_remover_7').style.display = 'none'
        document.getElementById('botao_adicionar_7').style.display = 'block'
        document.getElementById('flex_7').style.display = 'none'
        document.getElementById('caixa_adicional_id_7').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_7').value = ''
        calcular()
      })
      document.getElementById('botao_remover_8').addEventListener('click', function () {
        document.getElementById('botao_remover_8').style.display = 'none'
        document.getElementById('botao_adicionar_8').style.display = 'block'
        document.getElementById('flex_8').style.display = 'none'
        document.getElementById('caixa_adicional_id_8').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_8').value = ''
        calcular()
      })

      document.getElementById('botao_remover_9').addEventListener('click', function () {
        document.getElementById('botao_remover_9').style.display = 'none'
        document.getElementById('botao_adicionar_9').style.display = 'block'
        document.getElementById('flex_9').style.display = 'none'
        document.getElementById('caixa_adicional_id_9').value = ''
        document.getElementById('quantidade_por_caixa_adicional_id_9').value = ''
        calcular()
      })
    }
  }

  const calcular = () => {
    let numAdd0 = Number(document.getElementById('caixa_adicional_id_0').value, 10)
    let numAdd1 = Number(document.getElementById('caixa_adicional_id_1').value, 10)
    let numAdd2 = Number(document.getElementById('caixa_adicional_id_2').value, 10)
    let numAdd3 = Number(document.getElementById('caixa_adicional_id_3').value, 10)
    let numAdd4 = Number(document.getElementById('caixa_adicional_id_4').value, 10)
    let numAdd5 = Number(document.getElementById('caixa_adicional_id_5').value, 10)
    let numAdd6 = Number(document.getElementById('caixa_adicional_id_6').value, 10)
    let numAdd7 = Number(document.getElementById('caixa_adicional_id_7').value, 10)
    let numAdd8 = Number(document.getElementById('caixa_adicional_id_8').value, 10)
    let numAdd9 = Number(document.getElementById('caixa_adicional_id_9').value, 10)

    let num0 = Number(document.getElementById('0').value, 10)
    let num1 = Number(document.getElementById('1').value, 10)
    let num2 = Number(document.getElementById('2').value, 10)
    let num3 = Number(document.getElementById('3').value, 10)
    let num4 = Number(document.getElementById('4').value, 10)
    let num5 = Number(document.getElementById('5').value, 10)
    let num6 = Number(document.getElementById('6').value, 10)
    let num7 = Number(document.getElementById('7').value, 10)
    let num8 = Number(document.getElementById('8').value, 10)
    let num9 = Number(document.getElementById('9').value, 10)

    let caixa0 = Number(document.getElementById('quantidade_por_caixa_0').value, 10)
    let caixa1 = Number(document.getElementById('quantidade_por_caixa_1').value, 10)
    let caixa2 = Number(document.getElementById('quantidade_por_caixa_2').value, 10)
    let caixa3 = Number(document.getElementById('quantidade_por_caixa_3').value, 10)
    let caixa4 = Number(document.getElementById('quantidade_por_caixa_4').value, 10)
    let caixa5 = Number(document.getElementById('quantidade_por_caixa_5').value, 10)
    let caixa6 = Number(document.getElementById('quantidade_por_caixa_6').value, 10)
    let caixa7 = Number(document.getElementById('quantidade_por_caixa_7').value, 10)
    let caixa8 = Number(document.getElementById('quantidade_por_caixa_8').value, 10)
    let caixa9 = Number(document.getElementById('quantidade_por_caixa_9').value, 10)

    let caixaAdd0 = Number(document.getElementById('quantidade_por_caixa_adicional_id_0').value, 10)
    let caixaAdd1 = Number(document.getElementById('quantidade_por_caixa_adicional_id_1').value, 10)
    let caixaAdd2 = Number(document.getElementById('quantidade_por_caixa_adicional_id_2').value, 10)
    let caixaAdd3 = Number(document.getElementById('quantidade_por_caixa_adicional_id_3').value, 10)
    let caixaAdd4 = Number(document.getElementById('quantidade_por_caixa_adicional_id_4').value, 10)
    let caixaAdd5 = Number(document.getElementById('quantidade_por_caixa_adicional_id_5').value, 10)
    let caixaAdd6 = Number(document.getElementById('quantidade_por_caixa_adicional_id_6').value, 10)
    let caixaAdd7 = Number(document.getElementById('quantidade_por_caixa_adicional_id_7').value, 10)
    let caixaAdd8 = Number(document.getElementById('quantidade_por_caixa_adicional_id_8').value, 10)
    let caixaAdd9 = Number(document.getElementById('quantidade_por_caixa_adicional_id_9').value, 10)

    let inner_calcular_quantidade_por_caixa = document.getElementById('inner_calcular_quantidade_por_caixa')

    inner_calcular_quantidade_por_caixa.style.fontWeight = 800
    inner_calcular_quantidade_por_caixa.innerHTML =
      num0 +
      num1 +
      num2 +
      num3 +
      num4 +
      num5 +
      num6 +
      num7 +
      num8 +
      num9 +
      numAdd0 +
      numAdd1 +
      numAdd2 +
      numAdd3 +
      numAdd4 +
      numAdd5 +
      numAdd6 +
      numAdd7 +
      numAdd8 +
      numAdd9

    let inner_calcular_quantidade_de_caixa0 = document.getElementById('inner_calcular_quantidade_de_caixa_0')
    let inner_calcular_quantidade_de_caixa1 = document.getElementById('inner_calcular_quantidade_de_caixa_1')
    let inner_calcular_quantidade_de_caixa2 = document.getElementById('inner_calcular_quantidade_de_caixa_2')
    let inner_calcular_quantidade_de_caixa3 = document.getElementById('inner_calcular_quantidade_de_caixa_3')
    let inner_calcular_quantidade_de_caixa4 = document.getElementById('inner_calcular_quantidade_de_caixa_4')
    let inner_calcular_quantidade_de_caixa5 = document.getElementById('inner_calcular_quantidade_de_caixa_5')
    let inner_calcular_quantidade_de_caixa6 = document.getElementById('inner_calcular_quantidade_de_caixa_6')
    let inner_calcular_quantidade_de_caixa7 = document.getElementById('inner_calcular_quantidade_de_caixa_7')
    let inner_calcular_quantidade_de_caixa8 = document.getElementById('inner_calcular_quantidade_de_caixa_8')
    let inner_calcular_quantidade_de_caixa9 = document.getElementById('inner_calcular_quantidade_de_caixa_9')

    inner_calcular_quantidade_de_caixa9.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa9.style.color = '#77787b'
    let total9 = num9 * caixa9 + numAdd9 * caixaAdd9
    inner_calcular_quantidade_de_caixa9.innerHTML = total9

    inner_calcular_quantidade_de_caixa0.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa0.style.color = '#77787b'
    let total0 = num0 * caixa0 + numAdd0 * caixaAdd0
    inner_calcular_quantidade_de_caixa0.innerHTML = total0

    inner_calcular_quantidade_de_caixa1.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa1.style.color = '#77787b'
    let total1 = num1 * caixa1 + numAdd1 * caixaAdd1
    inner_calcular_quantidade_de_caixa1.innerHTML = total1

    inner_calcular_quantidade_de_caixa2.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa2.style.color = '#77787b'
    let total2 = num2 * caixa2 + numAdd2 * caixaAdd2
    inner_calcular_quantidade_de_caixa2.innerHTML = total2

    inner_calcular_quantidade_de_caixa3.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa3.style.color = '#77787b'
    let total3 = num3 * caixa3 + numAdd3 * caixaAdd3
    inner_calcular_quantidade_de_caixa3.innerHTML = total3

    inner_calcular_quantidade_de_caixa4.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa4.style.color = '#77787b'
    let total4 = num4 * caixa4 + numAdd4 * caixaAdd4
    inner_calcular_quantidade_de_caixa4.innerHTML = total4

    inner_calcular_quantidade_de_caixa5.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa5.style.color = '#77787b'
    let total5 = num5 * caixa5 + numAdd5 * caixaAdd5
    inner_calcular_quantidade_de_caixa5.innerHTML = total5

    inner_calcular_quantidade_de_caixa6.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa6.style.color = '#77787b'
    let total6 = num6 * caixa6 + numAdd6 * caixaAdd6
    inner_calcular_quantidade_de_caixa6.innerHTML = total6

    inner_calcular_quantidade_de_caixa7.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa7.style.color = '#77787b'
    let total7 = num7 * caixa7 + numAdd7 * caixaAdd7
    inner_calcular_quantidade_de_caixa7.innerHTML = total7

    inner_calcular_quantidade_de_caixa8.style.fontWeight = 800
    inner_calcular_quantidade_de_caixa8.style.color = '#77787b'
    let total8 = num8 * caixa8 + numAdd8 * caixaAdd8
    inner_calcular_quantidade_de_caixa8.innerHTML = total8

    const calculo_total = total0 + total1 + total2 + total3 + total4 + total5 + total6 + total7 + total8 + total9

    let total = document.getElementById('total')
    total.innerHTML = calculo_total
    total.style.fontWeight = 800

    document.getElementById('totalAlert').innerHTML = document.getElementById('inner_calcular_quantidade_por_caixa').innerHTML
    document.getElementById('totalAlert').style.fontWeight = 800

    document.getElementById('totalAlertItens').innerHTML = document.getElementById('total').innerHTML
    document.getElementById('totalAlertItens').style.fontWeight = 800

    document.getElementById('pesoTotalGramas').innerHTML = document.getElementById('gramas').value
    document.getElementById('pesoTotalGramas').style.fontWeight = 800

    if (document.getElementById('gramas').value !== '') {
      document.getElementById('kg').innerHTML = 'kg'
      document.getElementById('kg').style.fontWeight = 800
    }
  }

  console.log('dados_info_p_nota', props.dados_info_p_nota)

  return (
    <S.ModalContentGrid>
      <Flex w="105.3%" ml="-33px" h="75px" bgColor="#e5e5e5" justifyContent="space-between" align="center">
        {props.dados_info_p_nota.map((data, idx) => {
          if (idx <= 0) {
            return (
              <>
                <Flex ml="30px" w="130px">
                  <Text color="#FD7074">
                    <strong>PEDIDO:</strong>
                  </Text>
                  <Text ml="10px">
                    <strong>{data.numero_pedido}</strong>
                  </Text>
                </Flex>
                <S.ButtonEnviar
                  loadingButton={loadingButton}
                  marginLeft={'1rem'}
                  type="submit"
                  id="botao_info"
                  onClick={() => {
                    onOpen()
                  }}
                >
                  {loadingButton ? <span>ENVIANDO</span> : <span>ENVIAR</span>}
                </S.ButtonEnviar>
                {/*<Button*/}
                {/*  as={"a"}*/}
                {/*  target="_blank"*/}
                {/*  href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-etiqueta-sem-nf/${data.numero_nota}`}*/}
                {/*>*/}
                {/*  Imprimir Etiqueta*/}
                {/*</Button>*/}
                <S.ImageFecharModal id="close" sair={sair} src={'/images/pop-in-fechar-icon.svg'} onClick={props.closeButton} />
                <ModalDialog
                  focusButton={focusButton}
                  onClose={onClose}
                  isOpen={isOpen}
                  enviarInfoPNota={enviarInfoPNota}
                  loadingButton={loadingButton}
                />
              </>
            )
          }
        })}
      </Flex>
      {props.dados_info_p_nota.map((data, idx) => {
        return (
          idx === 0 && (
            <Flex justify="space-between" mt="15px" align="center" w="1000px" mx="auto">
              <Flex ml="15px" w="200px">
                <Text color="#FD7074">
                  <strong>TOTAL DE CAIXAS:</strong>
                </Text>
                <Text id="inner_calcular_quantidade_por_caixa" ml="10px"></Text>
              </Flex>
              <Flex ml="15px" w="250px">
                <Text color="#FD7074">
                  <strong>TOTAL DE PRODUTOS:</strong>
                </Text>
                <Text id="total" ml="10px"></Text>
              </Flex>
              <Flex align="center" justify="space-between" w="370px">
                <Text color="#FD7074">
                  <strong>PESO DO PRODUTO</strong>
                </Text>
                <InputGroup w="190px">
                  <S.ContentModalInputGrama
                    autoFocus
                    focusfalse={focusfalse}
                    borderColor={focusfalse ? '#FD7074' : '#414042'}
                    focusBorderColor={focusfalse ? '#FD7074' : '#414042'}
                    id="gramas"
                    name="gramas"
                    type="number"
                    onChange={handleInputOnChange}
                    placeholder={data.gramas.toString().replace(',', '.')}
                    onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                  />
                  <InputRightElement pointerEvents="none" color="gray.400" fontSize="1.2em" children="kg" />
                </InputGroup>
              </Flex>
            </Flex>
          )
        )
      })}
      <S.FlexTextModalFinalizar>
        <Flex bgColor="#fd7074" h="40px" align="center">
          <Text fontSize="16px" as="p" w="130px">
            CAIXA
          </Text>
          <Text fontSize="16px" as="p" w="200px">
            QUANTIDADE DE CAIXAS
          </Text>
          <Text fontSize="16px" as="p" w="200px">
            QUANTIDADE POR CAIXAS
          </Text>
        </Flex>
        <Flex h="40px" align="center" bgColor="#77787b" w="520px" justify="space-between">
          <Text fontSize="16px" as="p" w="100px">
            ADICIONAR
          </Text>
          <Text fontSize="16px" as="p" w="200px">
            CAIXA ADICIONAL
          </Text>
          <Text lineHeight="100%" fontSize="16px" as="p" w="200px">
            QUANTIDADE POR
            <br /> CAIXA ADICIONAL
          </Text>
        </Flex>
        <Flex bgColor="#fd7074" h="40px" align="center">
          <Text lineHeight="100%" fontSize="16px" as="p" w="170px">
            QUANTIDADE DE PRODUTOS
          </Text>
        </Flex>
      </S.FlexTextModalFinalizar>

      <form onSubmit={enviarInputs}>
        {props.dados_info_p_nota.map((data, idx) => {
          if (guardaChuva) {
            if (idx <= 9) {
              return (
                <S.FlexInputsTable key={'id_' + data.id}>
                  <Flex w="530px" justify="space-between" h="40px" align="center">
                    <Text textTransform="lowercase" fontSize="14px" mt="7px" w="130px" textAlign="center">
                      {data.dimensao_caixa}
                    </Text>
                    <Flex w="200px">
                      <Input
                        id={idx}
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={idx === 0 ? 'quantidade_de_caixa_guarda_chuva' : 'quantidade_de_caixa_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                    <Flex w="200px">
                      <Input
                        id={'quantidade_por_caixa_' + idx}
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={idx === 0 ? 'quantidade_por_caixa_guarda_chuva' : 'quantidade_por_caixa_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                  </Flex>

                  <Flex justify="space-between" w="520px">
                    <Button
                      variant="outline"
                      _focus={{ outline: '2px solid #414042' }}
                      colorScheme="green"
                      w="100px"
                      id={'botao_adicionar_' + idx}
                      display="block"
                    >
                      Adicionar
                    </Button>
                    <Flex w="100%" justify="space-around" id={'flex_' + idx} display="none">
                      <Button
                        variant="outline"
                        _focus={{ outline: '2px solid #414042' }}
                        colorScheme="red"
                        w="100px"
                        id={'botao_remover_' + idx}
                        display="none"
                      >
                        Remover
                      </Button>
                      <Input
                        id={'caixa_adicional_id_' + idx}
                        position="relative"
                        left="7px"
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={idx === 0 ? 'caixa_adicional_guarda_chuva' : 'caixa_adicional_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                      <Input
                        id={'quantidade_por_caixa_adicional_id_' + idx}
                        position="relative"
                        left="5px"
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={idx === 0 ? 'quantidade_por_caixa_adicional_guarda_chuva' : 'quantidade_por_caixa_adicional_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                  </Flex>
                  <Flex w="170px">
                    <Text id={'inner_calcular_quantidade_de_caixa_' + idx} fontSize="18px" textAlign="center" mx="auto" w="130px"></Text>
                  </Flex>
                </S.FlexInputsTable>
              )
            }
          } else {
            if (idx <= 9) {
              return (
                <S.FlexInputsTable key={'id_' + data.id}>
                  <Flex w="530px" justify="space-between" h="40px" align="center">
                    <Text textTransform="lowercase" fontSize="14px" mt="7px" w="130px" textAlign="center">
                      {data.dimensao_caixa}
                    </Text>
                    <Flex w="200px">
                      <Input
                        id={idx}
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={'quantidade_de_caixa_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                    <Flex w="200px">
                      <Input
                        id={'quantidade_por_caixa_' + idx}
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={'quantidade_por_caixa_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                  </Flex>

                  <Flex justify="space-between" w="520px">
                    <Button
                      variant="outline"
                      _focus={{ outline: '2px solid #414042' }}
                      colorScheme="green"
                      w="100px"
                      id={'botao_adicionar_' + idx}
                      display="block"
                    >
                      Adicionar
                    </Button>
                    <Flex w="100%" justify="space-around" id={'flex_' + idx} display="none">
                      <Button
                        variant="outline"
                        _focus={{ outline: '2px solid #414042' }}
                        colorScheme="red"
                        w="100px"
                        id={'botao_remover_' + idx}
                        display="none"
                      >
                        Remover
                      </Button>
                      <Input
                        id={'caixa_adicional_id_' + idx}
                        position="relative"
                        left="7px"
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={'caixa_adicional_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                      <Input
                        id={'quantidade_por_caixa_adicional_id_' + idx}
                        position="relative"
                        left="5px"
                        focusBorderColor="#414042"
                        mx="auto"
                        textAlign="center"
                        color="black"
                        w="130px"
                        name={'quantidade_por_caixa_adicional_id_' + data.id}
                        type="number"
                        placeholder={'0'}
                        onChange={handleInputOnChange}
                        onKeyPress={(e) => (e.key == 'Enter' ? onOpen() : null)}
                      />
                    </Flex>
                  </Flex>
                  <Flex w="170px">
                    <Text id={'inner_calcular_quantidade_de_caixa_' + idx} fontSize="18px" textAlign="center" mx="auto" w="130px"></Text>
                  </Flex>
                </S.FlexInputsTable>
              )
            }
          }
        })}
      </form>
    </S.ModalContentGrid>
  )
}

{
  /* <Input
    focusBorderColor="#414042"
    ml="10px"
    textAlign="center"
    color="black"
    w="160px"
    name={
      data.listar_caixas === "S"
        ? "qtd_guarda_chuva"
        : "id_" + data.id
    }
    type="number"
    placeholder={"0"}
    onChange={handleInputOnChange}
    onKeyPress={(e) => (e.key == "Enter" ? onOpen() : null)}
  /> */
}
